import { useEffect, useState } from "react";

// Module-level (in-memory) flag — persists across route changes/remounts within
// the same session. Resets only on full page reload.
let toolkitPopupDismissed = false;

export function useToolkitQuiz(delayMs = 15000) {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (toolkitPopupDismissed) return;
    const t = setTimeout(() => {
      if (toolkitPopupDismissed) return;
      toolkitPopupDismissed = true;
      setOpen(true);
    }, delayMs);
    return () => clearTimeout(t);
  }, [delayMs]);

  return {
    open,
    close: () => {
      toolkitPopupDismissed = true;
      setOpen(false);
    },
  };
}
